import { ConsentSettings } from "../consentSettings";
import { ContentInteraction } from "../interfaces";
import {
  AnalyticsProvider,
  ConversionEventDetail
} from "./analyticsProviderBase";

export class Matomo extends AnalyticsProvider {
  constructor() {
    super();
    this.name = "Matomo";
  }

  // start(_consent_settings: ConsentSettings): void {
  //   this.has_consent_to_run = _consent_settings.performance == true;

  //   if (!this.has_consent_to_run) {
  //     this.log("Matomo does not have permission to start");
  //     this.has_started = true;
  //     return;
  //   } else if (this.has_started) {
  //     return;
  //   } else {
  //     this.log("Matomo is starting...");
  //   }

  //   window.matomoAsyncInit = function () {
  //     sv.providers.matomo.has_started = true;
  //   };

  //   if (document.domain == "127.0.0.1") {
  //     this.log(
  //       "Skipping inserting the Matomo tag because you are running locally."
  //     );
  //   } else {
  //     (function () {
  //       const u = "https://silversea.matomo.cloud/";
  //       window._paq.push(["setTrackerUrl", u + "matomo.php"]);
  //       window._paq.push(["setSiteId", "5"]);
  //       const d = document,
  //         g = d.createElement("script"),
  //         s = d.getElementsByTagName("script")[0];
  //       g.type = "text/javascript";
  //       g.async = true;
  //       g.defer = true;
  //       g.src = "//cdn.matomo.cloud/silversea.matomo.cloud/matomo.js";
  //       s.parentNode.insertBefore(g, s);
  //     })();
  //   }
  //   return;
  // }

  private get_matomo_visitor_id_from_cookie(): string | null {
    const pk_id_cookies = document.cookie
      .split('; ')
      .filter(row => row.startsWith('_pk_id.5.'));
    
    if (pk_id_cookies.length === 0) {
      return null;
    }
    
    const cookie = pk_id_cookies[0];
    const value = cookie.split('=')[1];
    if (value) {
      const parts = value.split('.');
      if (parts.length > 0) {
        return parts[0];
      }
    }
    return null;
  }


  async get_visitor_id(): Promise<unknown> {
    // const timeout = new Promise(function (resolve, reject) {
    //   setTimeout(function () {
    //     reject("Matomo ID could not be retrieved.");
    //   }, 4000);
    // });

    // const p = new Promise((resolve, reject) => {
    //   if (!this.has_consent_to_run) {
    //     this.log("Consent not given to retrieve Matomo ID.");
    //     reject("Consent not given to retrieve Matomo ID.");
    //   } else {
    //     _paq.push([
    //       function () {
    //         const visitor_id = this.getVisitorId();
    //         if (typeof visitor_id == "string") {
    //           resolve(visitor_id);
    //         } else {
    //           reject("Unexpected type for Matomo ID: " + typeof visitor_id);
    //         }
    //       }
    //     ]);
    //   }
    // });

    // return Promise.race([p, timeout]).catch(function (e) {
    //   console.log(e);
    //   return null;
    // });

    const visitorId = this.get_matomo_visitor_id_from_cookie();
    if (visitorId) {
      return visitorId;
    } else {
      this.log("Matomo visitor ID not found in cookie.");
      return null;
    }
  }

  // conversion_triggered(_conversion_event_detail: ConversionEventDetail): void {
    // if (!this.has_consent_to_run) {
    //   return;
    // } else {
    //   this.log_conversion();
    // }

    // if (!this.has_started) {
    //   this.log("Matomo Conversion Skipped... Matomo is not running");
    // } else {
    //   this.log("Matomo web-request-submitted triggered");
    //   this.get_matomo_conversion_events(_conversion_event_detail).forEach(
    //     function (value) {
    //       console.log(value);
    //       window._paq.push(value);
    //     }
    //   );
    // }
  // }

  // get_matomo_conversion_events(
  //   _conversion_event_detail: ConversionEventDetail
  // ): Array<Array<string | number> | undefined> {
  //   const matomo_request_type_map = {
  //     RAQ: { form: "RequestAQuoteForm", goal: 9 },
  //     RAB: { form: "RequestBrochureForm", goal: 10 },
  //     SFO: { form: "SignupForOffersForm", goal: 11 },
  //     WEBQ: { form: "RequestWebQForm", goal: 12 },
  //     WBBK: { goal: 13 },
  //     "WBOF.01": { form: "guest-info", goal: 14 }
  //   };

  //   const res = [];
  //   const conv = matomo_request_type_map[_conversion_event_detail.request_type];
  //   if (conv?.form) {
  //     res.push(["FormAnalytics::trackFormConversion", conv.form]);
  //   }
  //   if (conv?.goal) {
  //     res.push(["trackGoal", conv.goal]);
  //   }
  //   return res;
  // }

  // interaction_triggered(_data_content_attribs: ContentInteraction): void {
    // THIS IS DISABLED DUE TO COST CUTTING, IT MAY BE RE-ENABLED ANOTHER TIME
    // if (!this.has_consent_to_run) {
    //   return;
    // } else {
    //   this.log_interaction();
    // }
    // if (this.has_started) {
    //   window._paq.push([
    //     "trackContentImpression",
    //     _data_content_attribs["data-content-name"],
    //     _data_content_attribs["data-content-piece"],
    //     _data_content_attribs["data-content-target"]
    //   ]);
    //   window._paq.push([
    //     "trackContentInteraction",
    //     _data_content_attribs["event_type"],
    //     _data_content_attribs["data-content-name"],
    //     _data_content_attribs["data-content-piece"],
    //     _data_content_attribs["data-content-target"]
    //   ]);
    //   this.log([
    //     "this.content_interaction_matomo()",
    //     _data_content_attribs["event_type"],
    //     _data_content_attribs["data-content-name"],
    //     _data_content_attribs["data-content-piece"],
    //     _data_content_attribs["data-content-target"]
    //   ]);
    // }
  // }

  // pageload_triggered(): void {
    // if (!this.has_consent_to_run) {
    //   return;
    // } else {
    //   this.log_pageload();
    // }
    // this.initialise_subscribers();

    // /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    // if (this.is_404_page()) {
    //   window._paq.push([
    //     "setDocumentTitle",
    //     "404/URL = " +
    //       encodeURIComponent(
    //         document.location.pathname + document.location.search
    //       ) +
    //       "/From = " +
    //       encodeURIComponent(document.referrer)
    //   ]);
    // } else {
    //   window._paq.push([
    //     "setDocumentTitle",
    //     document.domain + "/" + document.title
    //   ]);
    // }
    // window._paq.push(["setCookieDomain", "*.silversea.com"]);

    // this.setCustomDimension(2, this.get_user_country());
    // this.setCustomDimension(3, this.get_user_language());
    // if (!document.referrer.split("?")[0].includes("silversea.com")) {
    //   this.setCustomDimension(4, document.referrer);
    // }
    // this.setCustomDimension(5, document.referrer);

    // window._paq.push(["trackPageView"]);
    // window._paq.push(["enableLinkTracking"]);
    // //_paq.push(["trackVisibleContentImpressions"]);

    // // Track form conversions
  // }

  // setCustomDimension(
    // customDimensionId: number,
    // customDimensionValue: string
  // ): void {
    // _paq.push(["setCustomDimension", customDimensionId, customDimensionValue]);
  // }
}
